import type { FaireProductEntity } from "../../entity_types/product";

export const p_seuspqr253: FaireProductEntity = {
  token: "p_seuspqr253",
  type: "product",
  name: "Velvet Ring DISPLAY",
  brandToken: "b_azjmuj2qt2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/c52d3c3fe7ba0c68ce1c23193da0f387705d3fcbbf3b9d884f3ab77483ceb9d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abe00e65182e48f8284245dd98e8f5b96b84fcb18a375f10205e4e5f495da67d.jpeg",
    "https://cdn.faire.com/fastly/81b2b58fdbd7969b8ef267fab3fdb081d9be04f111a708e04e81cb48a0540850.jpeg",
    "https://cdn.faire.com/fastly/35c23aa27c6d07f4b738b8fea196c107deaba40517160faafce47912c37b5193.jpeg",
    "https://cdn.faire.com/fastly/4e21787ccd69350a06976f5efe9adc695a6547313d517feb1ba53cb354f93446.jpeg",
    "https://cdn.faire.com/fastly/445c9ee9f8e4266990128cb1fcbbd9c0a58a3a199526d7ee7bbedaebbcd8a48a.jpeg",
    "https://cdn.faire.com/fastly/4cd12f83b59f293712dcd94c02b29982a49e6a6b6f0320e896c415f559c0fffc.jpeg",
    "https://cdn.faire.com/fastly/4faf7f3a398657e3a8cc55f78016e86272e37b7d7b6ba1ec0795358ce2fd916f.jpeg",
    "https://cdn.faire.com/fastly/57efc924beb8d4c68423611f2ded5d53e1fba8d4a645ea2aad3da0f283e5a654.jpeg",
    "https://cdn.faire.com/fastly/a7cc179d5182fb167ba18187ec19af7b56097a1d510b38ff6fe80827fa34a323.jpeg",
    "https://cdn.faire.com/fastly/b7fbd3f11b993f8016efe633ea9e202dda0fcebff787f86e6adb8c7d03d5fb68.jpeg",
  ],
  priceDollars: 50.75,
  description:
    "See what rocks your world with our Velvet Ring Display! Get a dazzling view of your rings showcased in a variety of regal colors (red, black, navy, etc.). Keep your rings looking tip-top with this luxe velvet presentation. You'll be the talk of the town!\n",
  tags: [],
  msrpDollars: 101.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:29.324Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
